export default __webpack_public_path__ + "static/media/csf.525d7d4f.png";